import { getRelatedPositions } from 'services/Structure'

const getQuery = ({ users, scheduleTypes, vacationTypeId, positions, ...filter } = {}) => {
  let query = { ...filter }

  // TODO: if (!vm.showOnHoldProjects) query.hideOnHoldProjects = true
  if (typeof vacationTypeId !== 'undefined' && typeof filter.showAllPositions === 'undefined' && typeof filter.positions === 'undefined') {
    query.filterAll = true
  }

  if (Array.isArray(users)) {
    query.employeeIds = []

    for (const user of users) {
      if (user === 'unassigned') query.showUnassignedShifts = true
      else query.employeeIds.push(user)
    }
  }

  // set start and end times in query if filtering by scheduleType
  // the parsing is done so we don't have to query scheduleTypes directly
  if (typeof scheduleTypes !== 'undefined') {
    query.start = query.start || []
    scheduleTypes.map(hourMinute => query.start.push(hourMinute))
  }

  if (Array.isArray(positions)) query.positions = getRelatedPositions(positions, { parents: false })

  return query
}

export default getQuery
